// extracted by mini-css-extract-plugin
export default {"login":"login_login__ukULI","wrapper":"login_wrapper__58k2U","innerWrapper":"login_innerWrapper__KEsI0","otpBox":"login_otpBox__3lobh"};